export interface Bank {
  id: number;
  bik: string;
  name: string;
  bin: string;
}

export const BANKS: Bank[] = [
  { id: 1, bik: "CASPKZKA", name: 'АО "Kaspi Bank"', bin: "971240001315" },
  { id: 2, bik: "HSBKKZKX", name: 'АО "Народный банк Казахстана"', bin: "940140000385" },
  { id: 3, bik: "KCJBKZKX", name: 'АО "Банк ЦентрКредит"', bin: "980640000093" },
  { id: 4, bik: "IRTYKZKA", name: 'АО "ForteBank"', bin: "990740000683" },
  { id: 6, bik: "INLMKZKA", name: 'АО "Home Credit Bank"', bin: "930540000147" },
  { id: 8, bik: "KSNVKZKA", name: 'АО "Фридом банк Казахстан"', bin: "930440000156" },
  { id: 9, bik: "ATYNKZKA", name: 'АО "Altyn Bank"', bin: "980740000057" },
  { id: 10, bik: "TSESKZKA", name: 'АО "Alatau City Bank"', bin: "920140000084" },
  { id: 11, bik: "SHBKKZKA", name: 'АО "Шинхан банк Казахстан"', bin: "080240019735" },
  { id: 12, bik: "NURSKZKX", name: 'АО "Нурбанк"', bin: "930940000164" },
  { id: 16, bik: "KZIBKZKA", name: 'АО "ДБ "Казахстан-Зираат Интернешнл банк"', bin: "930140000323" },
  { id: 17, bik: "MOKFKZKA", name: "АО «Коммерческий банк БиЭнКей»", bin: "180640000680" },
  { id: 18, bik: "VTBAKZKZ", name: "ДО АО Банк ВТБ (Казахстан)", bin: "080940010300" },
  { id: 19, bik: "KMFBKZKK", name: 'АО "КМФ банк"', bin: "061240001583" },
  { id: 20, bik: "KINCKZKA", name: 'АО "Банк "Bank RBK"', bin: "920440001102" },
  { id: 21, bik: "BRKEKZKA", name: 'АО "Bereke Bank"', bin: "930740000137" },
  { id: 22, bik: "EURIKZKA", name: 'АО "Евразийский банк"', bin: "950240000112" },
];
